'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormControlComponent = require('./FormControlComponent');

var _FormControlComponent2 = _interopRequireDefault(_FormControlComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a text input field.
 * @extends {Component}
 */
var TextInputComponent = function (_React$Component) {
  _inherits(TextInputComponent, _React$Component);

  function TextInputComponent() {
    _classCallCheck(this, TextInputComponent);

    return _possibleConstructorReturn(this, (TextInputComponent.__proto__ || Object.getPrototypeOf(TextInputComponent)).apply(this, arguments));
  }

  _createClass(TextInputComponent, [{
    key: 'render',
    value: function render() {
      var value = this.props.field.value;

      value = this.props.type === 'num' ? value.replace(/[^0-9]/g, '') : value;

      if (this.props.id === 'tugoExpiry' && value.length >= 6) {
        value = value.substring(0, 4) + '-' + value.substring(4, 6);
        this.props.field.value = value;
      }

      if (this.props.type === 'percentage') {
        this.props.field.value = this.props.field.value.replace(/^(100|\d{0,2}(\.\d{0,2})?).*$/, '$1');
      }

      var className = this.props.className ? this.props.className : '';
      return _react2.default.createElement(_FormControlComponent2.default, _extends({}, this.props, {
        field: this.props.field,
        formControlType: this.props.type,
        className: className + ' ingle-form-text-input',
        placeholder: this.props.htmlPlaceholder,
        formControlMinimum: this.props.min,
        maxLength: this.props.maxLength && this.props.maxLength
      }));
    }
  }]);

  return TextInputComponent;
}(_react2.default.Component);

TextInputComponent.propTypes = {
  id: _react2.default.PropTypes.string.string,
  field: _react2.default.PropTypes.object.isRequired,
  htmlPlaceholder: _react2.default.PropTypes.string,
  type: _react2.default.PropTypes.string,
  min: _react2.default.PropTypes.number,
  className: _react2.default.PropTypes.string,
  maxLength: _react2.default.PropTypes.number
};
TextInputComponent.defaultProps = {
  type: 'text'
};
exports.default = TextInputComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/TextInputComponent.jsx
// module id = 49
// module chunks = 0